import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import Icon from './Icon';
import { APP_NAME } from '../lib/brand';
import { backendConfigured, supabase } from '../lib/supabase';
import { useAppState } from './StateProvider';

const nav = [
  ['/', 'Today', 'home'],
  ['/week', 'This week', 'calendar'],
  ['/shop', 'Shop', 'cart'],
  ['/kitchen', 'Kitchen', 'kitchen'],
  ['/recipes', 'Recipes', 'recipes'],
  ['/household', 'Household', 'users'],
] as const;

export default function AppShell() {
  const { loading, state } = useAppState();
  const navigate = useNavigate();
  const kidFriendly = Boolean(state.kidFriendlyMode);
  async function signOut() { if (supabase) await supabase.auth.signOut(); navigate('/login', { replace: true }); }
  if (loading) return <div className="auth-loading">Syncing your Weekstead household…</div>;
  return (
    <div className={`app-shell${kidFriendly ? ' kid-friendly' : ''}`}>
      <aside className="sidebar">
        <div className="brand-lockup">
          <div className="brand-icon image"><img src="/weekstead-icon.png" alt="" /></div>
          <div><strong>{APP_NAME}</strong><span>A Roka Industries company</span></div>
        </div>
        <nav className="desktop-nav">
          {nav.map(([to, label, icon]) => <NavLink to={to} key={to} end={to === '/'} className={({ isActive }) => isActive ? 'active' : ''}><Icon name={icon} /> <span>{label}</span></NavLink>)}
        </nav>
        <div className="sidebar-foot">
          {kidFriendly && <div className="sidebar-mode">Kid-Friendly Mode on</div>}
          <span className="status-dot" /> {backendConfigured ? 'Production connected' : 'Demo workspace'}<br />
          <small>{backendConfigured ? 'Household sync active' : 'Local demo build'}</small>
          <small className="inspiration-mark">Inspired by WWJ</small>
          {backendConfigured && <button className="signout-link" onClick={signOut}>Sign out</button>}
        </div>
      </aside>
      <main className="main"><Outlet /></main>
      <nav className="bottom-nav">
        {nav.map(([to, label, icon]) => <NavLink to={to} key={to} end={to === '/'} className={({ isActive }) => isActive ? 'active' : ''}><Icon name={icon} /><span>{label}</span></NavLink>)}
      </nav>
    </div>
  );
}